import React from 'react';
import { Text } from '@chakra-ui/react';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog';

type DeleteGoalDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  goalTitle: string;
  isLoading: boolean;
};

export const DeleteGoalDialog: React.FC<DeleteGoalDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  goalTitle,
  isLoading,
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Delete Goal"
      bodyText={
        <Text>
          Are you sure you want to delete <strong>{goalTitle}</strong>? This
          action cannot be undone.
        </Text>
      }
      confirmText="Delete"
      isLoading={isLoading}
    />
  );
};
